import { useContextState } from "../../../../../../../../hooks/theme"

const useGoBackToListStyles = () => {
    const { colors } = useContextState()
    return {
        goBack: {
            color: colors.color16,
            fontSize: '1.5rem',
            '& .MuiSvgIcon-root': {
                fontSize: '1em',
            },
        },
        goBackText: {
            fontSize: '16px',
            fontWeight: '500',
            marginLeft: '5px',
            color: colors.color16,
        },
        flex: {
            display: 'flex',
            flexWrap: 'wrap',
            width: '100%',
            alignItems: 'center',
            '&.flex-jc-sb': {
                justifyContent: 'space-between',
            },
        },
    }
}

export { useGoBackToListStyles }